<template>
  <vv-provider tag="div" class="rating" rules="min_value:1">
    <input type="hidden" :value="stars">
    <ul class="list">
      <li :key="star" v-for="star in maxStars" :class="{ 'active': star <= stars }" @click="rate(star)" class="star">
        <label class="list__icon fa" :class="star <= stars ? 'fa-star' : 'fa-star-o'" :title="`${stars} sur ${maxStars}`"></label>
      </li>
    </ul>
  </vv-provider>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    maxStars: {
      type: Number,
      default: 5
    }
  },
  data () {
    return {
      stars: this.value
    }
  },
  methods: {
    rate (star) {
      if (
        typeof star === 'number' &&
        star <= this.maxStars &&
        star >= 0
      ) this.stars = this.stars === star ? star - 1 : star
      this.$emit('input', this.stars)
    }
  }
}
</script>
